import { useQuery } from 'react-query';
import { useQueryData } from 'src/api/components';
import { getSelfTestEditVersion } from 'src/api/queries/getSelfTestEditVersion';
import { getSelfTestPublishedVersion } from 'src/api/queries/getSelfTestPublishedVersion';
import { getUrlParam } from 'src/utils/getUrlParam';

export const useGetSelfTest = () => {
  const selftTestSlug = getUrlParam('edit');

  const query = useQuery(['getSelfTest', selftTestSlug], () => {
    return selftTestSlug
      ? getSelfTestEditVersion(selftTestSlug)
      : getSelfTestPublishedVersion();
  });
  return useQueryData(query);
};
